import { render } from "./StepOrderMemberCard.vue?vue&type=template&id=f37d7972&scoped=true"
import script from "./StepOrderMemberCard.vue?vue&type=script&lang=js"
export * from "./StepOrderMemberCard.vue?vue&type=script&lang=js"

import "./StepOrderMemberCard.vue?vue&type=style&index=0&id=f37d7972&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f37d7972"]])

export default __exports__